import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import rules from "../../../utils/rules";
export default {
  name: "add-geo-fence",
  components: { pageheader },
  data() {
    return {
      rules: rules,
      input: {},
      loading: false,
      isCreating: false,
      center: {},
      zoom: 8,
      polygonOptions: {
        strokeColor: "#880808",
        strokeOpacity: 0.8,
        strokeWeight: 5,
        fillColor: "#880808",
        fillOpacity: 0.35,
      },
      geofencePaths: [],
      userCurrentLocation: {},
      finalGeofencePaths: [],
      name: "",
      description: "",
      valid: true,
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "id",
      "fullname",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  mounted() {
    this.input = utils.getInputContent("addGeofence", this.roles);
    this.geolocate1();
  },
  methods: {
    geolocate1: function () {
      navigator.geolocation.getCurrentPosition(() => {
        this.userCurrentLocation = {
          lat: 47.6062095,
          lng: -122.3320708,
        };
        this.center = this.userCurrentLocation;
        this.geofencePaths = [];
        this.geofencePaths.push(this.userCurrentLocation);
        this.geofencePaths.push(this.userCurrentLocation);
      });
    },
    getCurrentZoom() {
      this.polygonOptions.strokeWeight = "5";
    },
    getCurrentCenter(center) {
      this.userCurrentLocation = {
        lat: center.latLng.lat(),
        lng: center.latLng.lng(),
      };
      this.center = this.userCurrentLocation;
      this.geofencePaths = [];
      this.geofencePaths.push(this.userCurrentLocation);
      this.geofencePaths.push(this.userCurrentLocation);
    },
    updatePath(mvcArray) {
      this.finalGeofencePaths = [];
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let p = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          p.push({
            lat: mvcArray.getAt(i).getAt(j).lat(),
            lng: mvcArray.getAt(i).getAt(j).lng(),
          });
        }
        this.finalGeofencePaths = p;
      }
    },
    async createGeofence() {
      if (this.finalGeofencePaths.length >= 3) {
        this.finalGeofencePaths.push(this.finalGeofencePaths[0]);
        this.isCreating = true;
        try {
          let payload = {
            name: this.name,
            description: this.description,
            customerId:
              this.companyNameDropdown == "All" ||
              this.companyNameDropdown == "" ||
              this.companyNameDropdown == null
                ? ""
                : String(this.companyIdDropdown),
            customerName:
              this.companyNameDropdown == "All" ||
              this.companyNameDropdown == "" ||
              this.companyNameDropdown == null
                ? ""
                : this.companyNameDropdown,

            polygons: this.finalGeofencePaths,
            userName: this.fullname,
            createdBy: this.fullname,
            userId: this.id,
          };
          let response = await telematicsService.createGeofence(payload);
          if (response.isSuccess) {
            this.$toast.success("Geofence added successfully");
            this.isCreating = false;
            this.$router.push({
              path: "/geofences/list",
            });
          } else {
            this.$toast.error(response.systemMessage);
            this.isCreating = false;
          }
        } catch (err) {
          this.isCreating = false;
          this.$toast.error("Unable to add the Geofence" + err);
        }
      } else {
        this.$toast.error("Invalid Geofence, Please draw valid Geofence.");
      }
    },
    goBack() {
      this.$router.push({
        path: "/geofences/list",
      });
    },
  },
};
